<template>
  <div class="qiluPage">
    <div class="topDiv">
      <h6 class="h6Text">请选择领卡网点</h6>
    </div>
    <b-container fluid>
      <div>
        <!-- <hr>
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-name">姓名</label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="name" id="input-name" type="text" placeholder="请输入办卡人姓名"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">手机号</label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="mobile" id="input-mobile" type="tel" maxlength="11" placeholder="请输入手机号"></b-form-input>
          </b-col>
        </b-row>
        <hr> -->
        <!-- 省市区选择 -->
        <b-row class="rowItem">
          <b-col cols="4">
            <b-form-select
              v-model="provinceText"
              :options="provinceS"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-col>
          <b-col cols="4">
            <b-form-select
              v-model="cityText"
              :options="cityS"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-col>
          <b-col cols="4">
            <b-form-select
              v-model="bankCode"
              :options="options"
              size="sm"
              class="mt-3"
            ></b-form-select>
          </b-col>
        </b-row>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label>网点</label>
          </b-col>
          <b-col cols="9">
            <b-form-select
              v-model="wangdian"
              :options="wangdian_options"
            ></b-form-select>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="1">
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />
          </b-col>
          <b-col>
            我已经阅读<font color="red" @click="showRules()"
              >《齐鲁银行DIY借记卡线上申请客户须知》</font
            >并同意相关内容。
            <!-- 我授权齐鲁银行将本人申请信息提供给齐鲁银行个性化定制卡业务合作方。 -->
          </b-col>
        </b-row>

        <b-row class="rowBtn">
          <b-col cols="10" class="mx-auto">
            <b-button
              :disabled="disabled"
              block
              variant="primary"
              @click="commitUserInfo()"
              >下一步</b-button
            >
          </b-col>
        </b-row>
        <b-row class="rowItemFee">
          <b-col style="font-size: 14px; color: #777777">
            温馨提示：<br />
            下一步将跳转至我行合作伙伴恒宝股份有限公司页面，进行图片上传、编辑及费用结算，相关责任由恒宝股份有限公司承担。
            <!-- 下一步将由我行合作伙伴恒宝股份有限公司对图片进行处理及卡片费用结算。 -->
          </b-col>
        </b-row>
      </div>

      <b-modal
        ref="rules"
        ok-only
        scrollable
        ok-title="确定"
        header-class="justify-content-center"
      >
        <!-- <template v-slot:modal-title>
        <span style="font-size: 16px; font-weight: bold;">齐鲁银行DIY借记卡线上申请客户须知</span>
      </template> -->
        <template #modal-header>
          <div class="mx-auto">
            <span style="font-size: 16px; font-weight: bold"
              >齐鲁银行DIY借记卡线上申请客户须知</span
            >
          </div>
        </template>
        <!-- 借记卡线上办卡业务须知 -->
        <div style="font-size: 12px; text-indent: 2em">
          <div>
            一、齐鲁银行DIY借记卡线上申请业务指客户（以下简称“您”）通过齐鲁银行线上渠道申请指定卡种并指定卡面，齐鲁银行合作卡商根据您定制的卡面制作借记空白卡，并直邮至您指定的齐鲁银行网点。
          </div>
          <div>
            二、齐鲁银行DIY借记卡线上申请业务实行“实名申请、预约开户”。卡片在您办理领卡开户前不写入个人信息，无法作为齐鲁银行借记卡账户使用。
          </div>
          <div>
            三、齐鲁银行DIY借记卡邮寄至指定网点后，工作人员会及时联系您，您需持本人身份证原件到网点办理开户，若代办需提供本人签署的授权委托书及双方有效身份证件，代办开卡时，账户设置为初始密码，初始密码须本人持有效身份证件到齐鲁银行任一网点修改。若申请时客户为不满18周岁未成年人（16周岁以上能提供劳动收入证明的除外），办理DIY卡申领业务应由监护人代理办理，出具监护人和未成年人的有效身份证件，以及监护关系证明材料（户口簿、出生证明等）。16周岁以上、18周岁以下能提供劳动收入证明的个人可以持本人有效身份证件到指定网点办理。
          </div>
          <div>
            四、申办齐鲁银行DIY借记卡时，须填写“姓名”“身份证号”“手机号”，选择指定“营业网点”。DIY借记卡线上申请业务仅支持客户凭居民身份证申请,申请时填写的姓名须与开户人一致。
          </div>
          <div>
            五、同一客户在齐鲁银行只可申请一张DIY借记卡产品，若您申请DIY借记卡之后，到我行网点申请其他银行卡账户，则该账户将为II类账户。
          </div>
          <div style="font-weight: bold">
            六、齐鲁银行DIY借记卡卡面由齐鲁银行合作卡商恒宝股份有限公司印制，属于个性化定制产品，涉及多项特殊制卡工艺（如立金、专属卡基、数码印制等），您申请卡片将产生50元工本费，由恒宝股份有限公司向您收取并提供发票服务，若您确认申请即表示认可该产品的收费。
          </div>
          <div style="font-weight: bold">
            七、申请一经提交，相关信息不可修改，包括“姓名”“身份证号”“手机号”“领卡网点”，以及个性化卡面业务所选卡面。
          </div>
          <div style="font-weight: bold">
            八、出于制卡、服务等需要，您申请齐鲁银行DIY借记卡，即表示同意授权齐鲁银行将您的个人资料和信息披露给必要的第三方，范围仅限于该卡合作方、外包作业机构、增值服务提供方等。
          </div>
          <div style="font-weight: bold">
            九、您到指定网点领取卡片，若发现卡片存在印制或芯片质量问题须更换DIY借记卡，齐鲁银行须将卡片退回合作卡商检核，由于齐鲁银行不允许合作卡商保存您上传的图片，您须再次进行线上申请，因质量原因退回卡片的工本费由恒宝股份有限公司退还至您的账户。您的卡片领取成功视同卡片不存在质量问题，非质量原因齐鲁银行无法为您提供卡片重新印制服务。
          </div>
          <div>
            十、对经核实不符合监管和齐鲁银行账户与借记卡管理规则的申请，齐鲁银行有权主动取消、解除服务。
          </div>
          <div>
            十一、如业务办理过程中有疑问或投诉，请拨打齐鲁银行24
            小时客户服务热线:4006096588，或通过投诉专线0531-81679697反映。
          </div>
        </div>
      </b-modal>

      <b-modal
        ok-only
        ref="model_error"
        title="提示"
        @ok="handleOk"
        ok-title="确定"
      >
        <p>{{ errorMsg }}</p>
      </b-modal>

      <b-modal
        ref="model_bank_confirm"
        title="提示"
        @ok="handleBankConfirm"
        ok-title="确定"
        cancel-title="取消"
      >
        <p>
          尊敬的客户，请确认您持有我行个性化卡数量！如您没有我行个性化卡，可正常申请；
          如您持有超过4张（包含4张）个性化卡，想继续申请此卡片，在领取卡片及办理激活前，需将您至少一张存量卡片先销户。
        </p>
      </b-modal>

      <b-modal
        style="width: 80%"
        ref="model_user_info"
        hide-header-close
        @ok="handleUserInfo"
        content-class="shadow"
        ok-title="确定"
        cancel-title="取消"
      >
        <div style="font-size: 25px; text-align: center; margin-bottom: 10px">
          温馨提示：
        </div>
        <b-row>
          <b-col cols="12">
            <p style="color: #000; font-weight: 600; padding: 0 10px">
              您填写的全部信息一经提交不可修改，请您在我行工作人员联系您领卡后，持申请使用的有效证件原件到我行营业网点办理开户后方可正常用卡。是否继续？
              <br />如需咨询开卡事宜，可致电齐鲁银行客服热线：4006096588。
            </p>
          </b-col>
        </b-row>
        <!-- <hr />
        <b-row style="padding: 0 10px">
          <b-col cols="4" style="color: #777777"> 申卡人： </b-col>
          <b-col cols="8">
            {{ messageData.name }}
          </b-col>
        </b-row>
        <hr />
        <b-row style="padding: 0 10px">
          <b-col cols="4" style="color: #777777"> 手机号： </b-col>
          <b-col cols="8">
            {{ messageData.mobileNo }}
          </b-col>
        </b-row> -->
        <hr />
        <!-- <b-row style="padding: 0 10px">
          <b-col cols="4" style="color: #777777"> 身份证号码： </b-col>
          <b-col cols="8">
            {{ messageData.idCard }}
          </b-col>
        </b-row>
        <hr /> -->
        <b-row style="padding: 0 10px">
          <b-col cols="4" style="color: #777777"> 领卡网点： </b-col>
          <b-col cols="8" class="itemWordWrap">
            {{ address }}
          </b-col>
        </b-row>
      </b-modal>

      <!-- loading toast -->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">提交中</p>
        </div>
      </div>

      <div v-show="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <p class="weui-toast__content">{{ toastMsg }}</p>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "ApplyCard_ql",
  data() {
    return {
      status: "not_accepted",
      disabled: true, //是否可以下一步
      name: "",
      mobile: "", //当前页面用户输入的手机号码
      bankCode: null,
      address: null, //展示地址
      addressId: "", //接口上传地址id
      wangdian: null,
      messageData: "", //解密参数
      provinceText: null, //省id
      cityText: null, //市id
      provinceS: [
        {
          value: null,
          text: "请选择省份",
        },
      ], //省
      //市
      cityS: [
        {
          value: null,
          text: "请选择市",
        },
      ],
      //区
      options: [
        {
          value: null,
          text: "请选择区",
        },
      ],
      //网点
      wangdian_options: [
        {
          value: null,
          text: "请选择网点",
        },
      ],
      errorMsg: "",
      loading: false,
      showToast: false,
      toastMsg: "",
    };
  },
  activated() {
    console.log("activated->");
    let paramsData = this.$route.params; //JSON.parse(.orderInfo);
    console.log("paramsData", paramsData);
    this.messageData = paramsData;
    console.log("activated messageData->" + JSON.stringify(this.messageData));
    this.name = "";
    this.mobile = "";
    this.bankCode = null; //区
    this.provinceText = null; //省id
    this.cityText = null; //市id
    this.wangdian = null;
    this.address = null;
    this.addressId = null;
    this.disabled = true;
    this.status = "not_accepted";
  },
  created() {},
  mounted: function () {
    console.log("mounted->");
    this.getProvinceList(); //获取省信息
  },
  methods: {
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    //确定框
    handleUserInfo: function () {
      // this.$router.push({
      //   name: "SelectCardface_ql",
      //   params: {
      //     // ...this.messageData,
      //     // bankSerialNumber: bankSerialNumber,
      //     // bankCode: bankCode,
      //     // orderInfo: orderInfo, //this.$route.params.orderInfo
      //   },
      // });
      //提交事件
      this.getBankSn();
    },
    //获取省信息
    getProvinceList() {
      var formData = new FormData();
      formData.append("parentId", "");
      axios.post(config.config_ql.getProvinceInfoList, formData).then((res) => {
        let that = this;
        let data = res.data;
        var shengList = new Array(data.length + 1);
        var obj = new Object();
        obj.value = null;
        obj.text = "请选择省份";
        shengList[0] = obj;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          let info = new Object();
          info.value = item.id; //province_code
          info.text = item.name; //province
          shengList[i + 1] = info;
        }
        that.provinceS = shengList;
      });
    },
    showUserInfo: function () {
      this.$refs["model_user_info"].show();
    },
    handleBankConfirm: function () {
      this.showUserInfo();
    },
    showBankConfirm: function () {
      this.$refs["model_bank_confirm"].show();
    },

    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    //网点获取
    getWangdian: function (bankCode) {
      var that = this;
      // var formData = new FormData();
      // formData.append("ascriptionCode", this.bankCode);
      // formData.append("bankCode", config.config_ql.bankCode);
      let params = {
        ascriptionCode: config.config_ql.bankCode + "_" + this.bankCode,
        bankCode: config.config_ql.bankCode,
      };
      console.log("params--->", params);
      axios
        .post(config.config_ql.getBranchInfoNewByParam, params)
        .then(function (res) {
          console.log("res--->", res);
          let data = res.data;
          var wdList = new Array(data.length + 1);
          var obj = new Object();
          obj.value = null;
          obj.text = "请选择网点";
          wdList[0] = obj;
          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let info = new Object();
            info.value = item.branch_code;
            info.text = item.branch_name;
            wdList[i + 1] = info;
          }
          that.wangdian_options = wdList;
        });
    },
    //查询支行信息
    queryBankInfo: function () {
      var that = this;
      axios
        .get(config.config_ql.queryBankBranchList, {
          params: {
            bankCode: "01B1_", // "01B1_",
          },
        })
        .then(function (response) {
          console.log(response);
          let dataRes = response.data;
          if (dataRes.code != 0) {
            that.showToastMsg(dataRes.message);
            return;
          }
          let data = dataRes.bankList;
          var bankInfos = new Array(data.length + 1);
          var obj = new Object();
          obj.value = null;
          obj.text = "请选择分行";
          bankInfos[0] = obj;

          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let info = new Object();
            info.value = item.bankCode;
            info.text = item.bankName;
            bankInfos[i + 1] = info;
          }

          that.options = bankInfos;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //提交
    getBankSn: function () {
      console.log(`this.messageData`, this.messageData);
      var that = this;
      let orderInfo = that.$route.params.orderInfo;
      // let finalBankCode = this.bankCode + "_" + this.wangdian;
      let param = {
        clientName: this.messageData.name, //名称
        clientPhoneNumber: this.messageData.mobileNo, //手机号
        bankCode: config.config_ql.bankCode, //银行编号
        bankSubCode: "", //分行编码
        bankBranchCode: this.wangdian, //支行|网点编码 "01"
        address: this.address, //网点地址拼接
        bankSerialNumber: this.messageData.flowNo, //卡唯一号
      };
      console.log("param--->", param);
      that.showLoading();
      axios
        .post(config.config_ql.qiluSubmitUserInfo, param) //submitUserInfo    qiluSubmitUserInfo
        .then(function (response) {
          // {code: 0, message: "交易成功", backSerialNumber: "2d506a29aaf846d3947ce1acfa9b38ad"}
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            //成功跳转页面
            that.toSelectCardFace(
              data.backSerialNumber,
              data.bankCode,
              orderInfo
            );
          } else {
            console.log("提交用户信息失败：" + data.message);
            that.errorMsg = data.message;
            that.showErrorMsg();
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
        });
    },
    //确定提交
    commitUserInfo: function () {
      if (this.provinceText == null) {
        this.showToastMsg("请选择省");
        return;
      }
      if (this.cityText == null) {
        this.showToastMsg("请选择市");
        return;
      }

      if (this.bankCode == null) {
        this.showToastMsg("请选择区");
        return;
      }

      if (this.wangdian == null) {
        this.showToastMsg("请选择领卡网点");
        return;
      }

      this.showUserInfo(); //确定信息
    },
    //提交成功跳转页面
    toSelectCardFace: function (bankSerialNumber, bankCode, orderInfo) {
      // console.log('this.$route.params', this.$route.params)
      this.$router.replace({
        name: "SelectCardface_ql",
        params: {
          ...this.messageData,
          // bankSerialNumber: bankSerialNumber,
          // bankCode: bankCode,
          // orderInfo: orderInfo, //this.$route.params.orderInfo
        },
      });
    },
    showRules: function () {
      this.$refs["rules"].show();
    },
  },
  watch: {
    status: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (newval == "accepted") {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    //监听网点
    wangdian: function (newval, oldval) {
      // console.log(
      //   "wangdian newval:" + newval + "," + "wangdian oldval:" + oldval
      // );
      let wangdian, brankCode;
      if (newval == null) {
      } else {
        this.wangdian_options.forEach((item, index) => {
          if (item.value == this.wangdian) {
            // console.log('item :>> ', item);
            wangdian = item.text;
            brankCode = item.value;
          }
        });
        let sheng, shi, qu;
        //省
        this.provinceS.forEach((item, index) => {
          if (item.value == this.provinceText) {
            sheng = item.text;
          }
        });
        //市
        this.cityS.forEach((item, index) => {
          if (item.value == this.cityText) {
            shi = item.text;
          }
        });
        // 区
        this.options.forEach((item, index) => {
          if (item.value == this.bankCode) {
            qu = item.text;
          }
        });
        this.address = `${sheng}${shi}${qu}${wangdian}`;
        this.addressId = `01B1_${this.provinceText}_${this.cityText}_${this.bankCode}_${brankCode}`; //`${this.addressId}_${brankCode}`;
        // console.log("this.addressId", this.addressId);
        // console.log("this.address", this.address);
      }
    },
    //监听区
    bankCode: function (newval, oldval) {
      if (newval == null) {
        this.wangdian = null;
        this.wangdian_options = [
          {
            text: "请选择网点",
            value: null,
          },
        ];
        return;
      } else {
        this.wangdian = null;
        // console.log("newval:" + newval + "," + "oldval:" + oldval);
        let sheng, shi, qu;
        //省
        this.provinceS.forEach((item, index) => {
          if (item.value == this.provinceText) {
            sheng = item.text;
          }
        });
        //市
        this.cityS.forEach((item, index) => {
          if (item.value == this.cityText) {
            shi = item.text;
          }
        });
        // 区
        this.options.forEach((item, index) => {
          if (item.value == this.bankCode) {
            qu = item.text;
          }
        });

        //详细地址
        this.address = `${sheng}${shi}${qu}`; //${wangdian}
        this.addressId = `01B1_${this.provinceText}_${this.cityText}_${this.bankCode}`; //_${this.wangdian}
        // console.log("this.addressId", this.addressId);
        // console.log("this.address", this.address);
        this.getWangdian(`01B1_${this.bankCode}`);
      }
    },
    // 监听省下拉框
    provinceText: function (newval, oldval) {
      if (newval == null) {
        this.cityText = null;
        this.cityS = [
          {
            text: "请选择市",
            value: null,
          },
        ];
        return;
      } else {
        //获取市的数据
        this.cityText = null;
        var formData = new FormData();
        formData.append("parentId", newval); //provinceCode
        axios
          .post(config.config_ql.getCityInfoByParam, formData)
          .then((res) => {
            let that = this;
            let data = res.data;
            var shiList = new Array(data.length + 1);
            var obj = new Object();
            obj.value = null;
            obj.text = "请选择市";
            shiList[0] = obj;
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              let info = new Object();
              info.value = item.id; //city_code
              info.text = item.name; //city
              shiList[i + 1] = info;
            }
            that.cityS = shiList;
          });
      }
    },
    //监听市下拉框
    cityText: function (newval, oldval) {
      if (newval == null) {
        this.bankCode = null;
        this.options = [
          {
            text: "请选择区",
            value: null,
          },
        ];
        return;
      } else {
        //获取区的数据
        this.bankCode = null;
        var formData = new FormData();
        formData.append("parentId", newval); //cityCode
        axios
          .post(config.config_ql.getDistrictInfoByParam, formData)
          .then((res) => {
            let that = this;
            let data = res.data;
            var quList = new Array(data.length + 1);
            var obj = new Object();
            obj.value = null;
            obj.text = "请选择区";
            quList[0] = obj;
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              let info = new Object();
              info.value = item.id; //district_code
              info.text = item.name; //district_name
              quList[i + 1] = info;
            }
            that.options = quList;
          });
      }
    },
  },
};
</script>

<style scoped>
.topDiv {
  height: 40px;
  width: 100%;
  background: #eee;
  color: red;
  margin-top: 0px;
}
.topDiv .h6Text {
  line-height: 40px;
  padding-left: 15px;
  font-size: 14px;
}
.colIntr {
  padding-left: 0;
  padding: 0 15px;
  color: red;
}

.rowItem {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.col-3 {
  padding-right: 0;
}

.rowItemFee {
  margin-top: 1rem;
}

.rowBtn {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.img {
  width: 100%;
}

.innerText {
  text-indent: 2rem;
}

.itemWordWrap {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/qilubank/ApplyCard_ql.vue